import { Outlet } from 'react-router-dom';
import { DashboardSidebar, MobileSidebarTrigger } from './DashboardSidebar';
import { DashboardHeader } from './DashboardHeader';
import { generateRouteTitles, type DashboardConfig } from './dashboard-config';
import { useState } from 'react';
import { useIsMobile } from '@xanectech/ui/lib';
import { createLogger } from '@xanectech/lib';

interface DashboardLayoutProps {
  config: DashboardConfig;
}
const logger = createLogger('DashboardLayout');

function DashboardLayout({ config }: DashboardLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();

  const routeTitles =
    config.routeTitles ??
    generateRouteTitles(config.navigation, config.basePath);

  const handleToggleSidebar = () => {
    if (isMobile) setMobileOpen((open) => !open);
    else setSidebarCollapsed((collapsed) => !collapsed);
  };


  return (
    <div className='flex h-screen w-full overflow-hidden bg-background'>
      <DashboardSidebar
        branding={config.branding}
        navigation={config.navigation}
        basePath={config.basePath}
        user={config.user}
        onLogout={config.onLogout}
        collapsed={sidebarCollapsed}
        onCollapsedChange={setSidebarCollapsed}
        mobileOpen={mobileOpen}
        onMobileOpenChange={setMobileOpen}
        singleExpanded={config.singleExpanded}
      />
      <div className='flex flex-1 flex-col overflow-hidden'>
        <DashboardHeader
          routeTitles={routeTitles}
          user={config.user}
          notifications={config.notifications}
          onLogout={config.onLogout}
          mobileMenuTrigger={
            <MobileSidebarTrigger onClick={() => setMobileOpen(true)} />
          }
          onToggleSidebar={handleToggleSidebar}
        />
        <main className='flex-1 overflow-y-auto bg-muted/30 p-6'>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export { DashboardLayout, type DashboardLayoutProps };
